<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Oppgjør</h2>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="canDisable">
      <BooleanInput v-model="stepValues.disableBool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="isActive">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="isActive">
      <v-textarea box v-model="stepValues.comment" @input="updateFields" label="Kommentar"></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  computed: {
    finished: function () {
      if(!this.isActive) {
        return true
      }
      let allOk = true
      for(let b in this.stepValues.bool) {
        if(this.stepValues.bool[b].value == 0) {
          allOk = false
        }
      }
      if(allOk) {
        return true
      }
      else {
        if(this.stepValues.comment) {
          return true
        }
        this.$emit("error", "Vennligst kommenter ved svar \"Nei\"")
        return false
      }
    },
    canDisable: function() {
      if(this.config.canDisable !== undefined) {
        if(this.config.canDisable === true) {
          return true
        }
      }
      return false
    },
    isActive: function() {
      if(this.stepValues.disableBool !== undefined) {
        if(!this.stepValues.disableBool.settlementActive.value) {
          return false
        }
      }
      return true
    }
  }
}
</script>
